import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalAddConcernReport from "./ModalAddConcernReport";

const useModalAddConcernReport = (onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { 
        openState: false, mode: 'none', cr_id: null, school_id: null
    })  ;

    const onClickActivate = ( cr_id, mode, school_id) =>
    {
        setDialog ({ 
            openState: true, cr_id: cr_id, mode: mode, school_id: school_id
        });
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, cr_id: null, mode: 'none', school_id: null});
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, cr_id: null, mode: 'none', school_id: null});

        // Tell the parent we're done
        onSaveCompleted( key ) ;
    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && 
                    < ModalAddConcernReport cr_id={dialog.cr_id} school_id={dialog.school_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode} />
                }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalAddConcernReport ;
